import Svg from '@capsule/svg'
import type { ReactElement } from 'jsx-dom-cjs'
import './assets/styles/toast.css'
import 'svgs/cross.svg'

export default class Toast {
	private target: HTMLElement
	private content: string
	private toastDOM: ReactElement

	constructor({
		target = document.getElementById('corps') as HTMLElement,
		content
	}: {
		target?: HTMLElement
		content: string
	}) {
		this.target = target ?? (document.getElementById('corps') as HTMLElement)
		this.content = content
		this.toastDOM = this.toast()

		this.closeEvent = this.closeEvent.bind(this)
	}

	public init(): void {
		this.target.insertAdjacentElement('afterbegin', this.toastDOM)
		this.autoCloseToast()
	}

	public closeEvent(): void {
		this.toastDOM.classList.add('close')

		// Remove the toast from the DOM after animation
		setTimeout(() => {
			this.toastDOM.remove()
		}, 300)
	}

	private autoCloseToast(): void {
		setTimeout(() => {
			this.closeEvent()
		}, 5000)
	}

	toast(): ReactElement {
		return (
			<div className="toast">
				<div className="toast-content">{this.content}</div>
				<button className="toast-close" type="button" onClick={() => this.closeEvent()}>
					<Svg name="cross" />
				</button>
			</div>
		)
	}
}
